import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import type { LimitedAccessResponse } from "../types/patientStatus";
export const useLimitedAccess = (patientId: string) => {
  return useApi<LimitedAccessResponse>({
    queryOptions: {
      enabled: Boolean(patientId),
      queryKey: ["patient", "limited-access", patientId],
      queryFn: async () => {
        const response = await axiosInstance.get("/new-api/membership/status", {
          params: {
            patientId,
          },
        });
        return response.data;
      },
    },
  });
};
